import './install-form-renders'; // 注册form表单组件
import { install } from './install';

export * from './components';
export * from './modal';
export * from './uses';
export {
    install,
};

export default install;
